import { BASE_URL } from '../constants';

export default path => path === BASE_URL;
